module.exports = __webpack_public_path__ + "img/close.7f66b9f1.svg";